import { css, unsafeCSS } from 'lit';
import { MOBILE_MENU_ANIMATION_DURATION, HEADER_HEIGHT, FONT_FAMILY, COLOR_HOVER, COLOR_ACTIVE, COLOR_BUTTON_BLUE } from '../constants.js';

const animationDuration = unsafeCSS(`${MOBILE_MENU_ANIMATION_DURATION}ms`);
const headerHeight = unsafeCSS(`${HEADER_HEIGHT}px`);
const fontFamily = unsafeCSS(FONT_FAMILY);
const colorHover = unsafeCSS(COLOR_HOVER);
const colorActive = unsafeCSS(COLOR_ACTIVE);
const colorButtonBlue = unsafeCSS(COLOR_BUTTON_BLUE);

export const DxoStylesMobileMenu = css`
  :host {
    display: flex;
    flex-direction: column;
  }

  @keyframes slideIn {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes slideOut {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-100%);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  .mobile-menu-overlay {
    position: fixed;
    top: ${headerHeight};
    left: 0;
    width: 100%;
    height: calc(100% - ${headerHeight});
    background-color: rgba(1, 1, 1, 0.25);
    z-index: 999;
    animation: fadeIn ${animationDuration} ease-out forwards;
  }

  .mobile-menu-overlay.closing {
    animation: fadeOut ${animationDuration} ease-out forwards;
  }

  .default-mobile-menu {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      position: fixed;
      top: ${headerHeight};
      left: 0;
      width: 100%;
      height: calc(100% - ${headerHeight});
      background-color: white;
      z-index: 1000;
      padding: 24px;
      gap: 24px;
      box-sizing: border-box;

      overflow-y: scroll;
      animation: slideIn ${animationDuration} ease-out forwards;
    }
    
  .default-mobile-menu.closing {
    animation: slideOut ${animationDuration} ease-out forwards;
  }

  .mobile-menu-section {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .mobile-menu-section.submenu {
    gap: 0;
  }

  .mobile-header-tab {
      font-size: 16px;
      line-height: 1.5;
      color: #011728;
      font-family: ${fontFamily};
      text-decoration: none;
      padding: 12px 0;

      &:not(.submenu):hover {
        color: ${colorHover};
      }

      &.active {
        color: ${colorActive};
        font-weight: 600;
      }
    }

  .mobile-tab-group {
    display: flex;
    flex-direction: column;

    .mobile-header-tab.submenu {
      margin: 0;
      font-weight: 600;
      padding: 16px 0;
    }

    .mobile-sub-tabs {
      display: flex;
      flex-direction: column;
      padding: 0 16px;
    }

    .mobile-sub-tab {
      font-size: 14px;
      line-height: 20px;
      color: #011728;
      font-family: ${fontFamily};
      text-decoration: none;
      text-align: left;
      padding: 16px;
      background: none;
      border: none;
      width: 100%;
      cursor: pointer;

      &:hover {
        color: ${colorHover};
      }

      &:hover > span {
        box-shadow: inset 0 -2px 0 ${colorHover};
        padding-bottom: 16px;
      }
    }

    .mobile-sub-tab.submenu {
      padding: 16px 0;
      color: #10253F;

      &:hover {
        color: ${colorHover};
      }
    }

    .mobile-sub-tab.submenu.active {
      color: ${colorActive};
    }
  }

  .mobile-collapsible-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    color: #011728;
    font-family: ${fontFamily};
    font-weight: 600;
    text-align: left;
    padding: 16px 0;
    background: none;
    border: none;
    cursor: pointer;

    &:hover {
      color: ${colorHover};
    }
  }

  .mobile-collapsible-chevron {
    display: flex;
    align-items: center;
    transition: transform 200ms ease;

    &.expanded {
      transform: rotate(180deg);
    }
  }

  .mobile-collapsible-content {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 200ms ease;

    &.expanded {
      grid-template-rows: 1fr;
    }

    > div {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      padding: 0 32px 0 16px;
    }
  }

  .mobile-logout {
    width: 40%;
  }

  .mobile-menu-auth {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: auto;
    box-shadow: inset 0 2px 0 #e6e6e6;
    padding: 16px 0;
  }

  .mobile-submenu-back {
    display: flex;
    align-items: center;
    gap: 8px;
    background: none;
    border: none;
    padding: 12px 0;
    font-size: 16px;
    line-height: 1.5;
    font-family: ${fontFamily};
    cursor: pointer;
    color: ${colorButtonBlue};
    font-weight: 600;
  }

  .mobile-submenu-back:hover {
    background-color: aliceblue;
  }

  .logout-dropdown-header.mobile:hover .logout-dropdown-name {
    color: ${colorHover};
  }

  .mobile-menu-profile {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    gap: 16px;
    height: ${headerHeight};
    background: none;
    border: none;
    text-decoration: none;
    padding: 0 2px;
  }

  .mobile-menu-profile-text {
    font-size: 16px;
    color: #141414;
    font-family: ${fontFamily};
  }

  a.mobile-menu-profile:hover, button.mobile-menu-profile:hover {
    background-color: aliceblue;
    cursor: pointer;
  }

  a.mobile-menu-profile:hover > .mobile-menu-profile-text, button.mobile-menu-profile:hover > .mobile-menu-profile-text {
    color: #0276b1;
  }

  :host([theme="dark"]) .default-mobile-menu {
    background-color: hsl(0, 0%, 12%);
  }

  :host([theme="dark"]) .mobile-header-tab {
    color: hsl(0, 0%, 100%);
  }

  :host([theme="dark"]) .mobile-tab-group .mobile-sub-tab {
    color: hsl(0, 0%, 85%);
  }

  :host([theme="dark"]) .mobile-tab-group .mobile-sub-tab.submenu {
    color: hsl(0, 0%, 85%);
  }

  :host([theme="dark"]) .mobile-tab-group .mobile-sub-tab:hover {
    color: hsl(0, 0%, 100%);
  }

  :host([theme="dark"]) .mobile-collapsible-toggle {
    color: hsl(0, 0%, 100%);
  }

  :host([theme="dark"]) .mobile-menu-auth {
    box-shadow: inset 0 2px 0 hsl(0, 0%, 25%);
  }

  :host([theme="dark"]) .mobile-menu-profile-text {
    color: hsl(0, 0%, 100%);
  }

  :host([theme="dark"]) .mobile-submenu-back {
    color: hsl(200, 85%, 65%);
  }

  :host([theme="dark"]) .mobile-submenu-back:hover {
    background-color: hsl(0, 0%, 18%);
  }

  :host([theme="dark"]) a.mobile-menu-profile:hover,
  :host([theme="dark"]) button.mobile-menu-profile:hover {
    background-color: hsl(0, 0%, 18%);
  }

  :host([theme="dark"]) .logout-dropdown-name {
    color: hsl(0, 0%, 100%);
  }
`;
